import { TasksKanbanGrouppingTypeEnum, TaskViewElementEnum } from "@/components/tasks-kanban/enums";

export class AttributesLocalStorageService {
  private static readonly GROUPPING_TYPE_KEY = "ATTRIBUTE_GROUPPING_TYPE";
  private static readonly VIEW_ELEMENTS_TYPE_KEY = "ATTRIBUTE_VIEW_ELEMENTS";

  /**
   * Формирует ключ с учетом контекста
   * @param key Основной ключ
   * @param context Контекст (namespace)
   * @returns Полный ключ
   */
  private static getKeyWithContext(key: string, context: string): string {
    return `${context}_${key}`;
  }

  private static saveData<T>(key: string, context: string, queueId: string, data: T) {
    const fullKey = this.getKeyWithContext(key, context);
    const lsData = localStorage.getItem(fullKey);
    if (!lsData) {
      localStorage.setItem(
        fullKey,
        JSON.stringify([
          {
            queueId,
            ...data,
          },
        ]),
      );
    } else {
      try {
        const items = JSON.parse(lsData);
        const findItem = items.find((item: any) => item.queueId === queueId);
        if (findItem) {
          Object.assign(findItem, data);
        } else {
          items.push({ queueId, ...data });
        }
        localStorage.setItem(fullKey, JSON.stringify(items));
      } catch (e) {
        console.error(e);
        localStorage.setItem(
          fullKey,
          JSON.stringify([
            {
              queueId,
              ...data,
            },
          ]),
        );
      }
    }
  }

  private static getData<T>(key: string, context: string, queueId: string): T | undefined {
    const fullKey = this.getKeyWithContext(key, context);
    const lsData = localStorage.getItem(fullKey);
    if (!lsData) return;
    try {
      const items = JSON.parse(lsData);
      return items.find((item: any) => item.queueId === queueId);
    } catch (e) {
      console.error(e);
    }
  }

  static saveGrouppingType(
    queueId: string,
    grouppingType: TasksKanbanGrouppingTypeEnum,
    context = "default",
  ) {
    this.saveData(this.GROUPPING_TYPE_KEY, context, queueId, { grouppingType });
  }

  static getGrouppingType(
    queueId: string,
    context = "default",
  ): TasksKanbanGrouppingTypeEnum | undefined {
    return this.getData<{ grouppingType: TasksKanbanGrouppingTypeEnum }>(
      this.GROUPPING_TYPE_KEY,
      context,
      queueId,
    )?.grouppingType;
  }

  static saveViewElements(
    queueId: string,
    viewElements: Array<TaskViewElementEnum>,
    context = "default",
  ) {
    this.saveData(this.VIEW_ELEMENTS_TYPE_KEY, context, queueId, { viewElements });
  }

  static getViewElements(
    queueId: string,
    context = "default",
  ): Array<TaskViewElementEnum> | undefined {
    return this.getData<{ viewElements: Array<TaskViewElementEnum> }>(
      this.VIEW_ELEMENTS_TYPE_KEY,
      context,
      queueId,
    )?.viewElements;
  }
}
